const adminRouterList = [
  // 校长首页
  {
    path: "/background",
    name: "admin-index",
    redirect: "/background/data-analysis",
    component: () => import("@/pages/admin/index"),
    children: [
      {
        path: "/background/data-analysis",
        name: "data-analysis",
        component: () => import("@/pages/admin/data-analysis"),
        meta: {
          activeMenu: "data-analysis",
        },
      },

      {
        path: "/background/data-history",
        name: "history",
        component: () => import("@/pages/admin/data-analysis/history"),
        meta: {
          activeMenu: "data-analysis",
        },
      },
      {
        path: "/background/system-notice",
        name: "system-notice",
        component: () => import("@/pages/admin/system-notice/system-notice"),
        meta: {
          activeMenu: "system-notice",
        },
      },

      //销售
      {
        path: "/background/market-trial",
        name: "market-trial",
        component: () => import("@/pages/admin/market/market-trial"),
        meta: {
          activeMenu: "market-trial",
        },
      },

      //客户实施看板
      {
        path: "/background/csm-basic",
        name: "csm-basic",
        component: () => import("@/pages/admin/csm/csm-basic"),
        meta: {
          activeMenu: "csm-basic",
        },
      },

      {
        path: "/background/csm-grow",
        name: "csm-grow",
        component: () => import("@/pages/admin/csm/csm-grow"),
        meta: {
          activeMenu: "csm-grow",
          keepAlive: true,
        },
      },

      {
        path: "/background/csm-teach",
        name: "csm-teach",
        component: () => import("@/pages/admin/csm/csm-teach"),
        meta: {
          activeMenu: "csm-teach",
        },
      },

      {
        path: "/background/school-history",
        name: "school-history",
        component: () => import("@/pages/admin/csm/school-history"),
        meta: {
          activeMenu: "csm-grow",
        },
      },

      {
        path: "/background/course-management/course-subject",
        name: "course-subject",
        component: () =>
          import("@/pages/admin/course-management/course-subject"),
      },
      {
        path: "/background/course-management/platform-curriculum",
        name: "platform-curriculum",
        component: () =>
          import("@/pages/admin/platform-course/platform-curriculum"),
        meta: {
          activeMenu: "platform-curriculum",
          keepAlive: true,
        },
      },

      {
        path: "/background/course-management/school-curriculum",
        name: "school-curriculum",
        component: () =>
          import("@/pages/admin/school-course/school-curriculum"),
        meta: {
          activeMenu: "school-curriculum",
        },
      },
      {
        path: "/background/course-management/codeprompt",
        name: "codeprompt",
        component: () =>
          import("@/pages/admin/school-course/codeprompt"),
        meta: {
          activeMenu: "codeprompt",
        },
      },

      {
        path: "/background/course-management/preview-curriculum",
        name: "preview-curriculum",
        component: () =>
          import("@/pages/admin/school-course/preview-curriculum"),
        meta: {
          activeMenu: "school-curriculum",
        },
      },

      {
        path: "/background/course-management/look-curriculum",
        name: "look-curriculum",
        component: () => import("@/pages/admin/school-course/look-curriculum"),
        meta: {
          activeMenu: "school-curriculum",
        },
      },

      {
        path: "/background/course-management/create-course-system",
        name: "create-admin-course-system",
        component: () =>
          import("@/pages/admin/platform-course/create-curriculum-system"),
        meta: {
          activeMenu: "course-system",
        },
      },
      {
        path: "/background/course-management/edit-course-system",
        name: "edit-admin-course-system",
        component: () =>
          import("@/pages/admin/platform-course/edit-curriculum-system"),
        meta: {
          activeMenu: "platform-curriculum",
        },
      },
      {
        path: "/background/course-management/relation",
        name: "relation",
        component: () =>
          import("@/pages/admin/platform-course/relation"),
        meta: {
          activeMenu: "platform-curriculum",
        },
      },
      //体验账号
      {
        path: "/background/experience-campus",
        name: "experience-campus",
        component: () =>
          import("@/pages/admin/school-management/experience-campus/index.vue"),
        meta: {
          activeMenu: "experience-campus",
        },
      },
      //赛考中心
      {
        path: "/background/testing/topic",
        name: "topic",
        component: () => import("@/pages/admin/testing/topic"),
        meta: {
          activeMenu: "topic",
        },
      },
      {
        path: "/background/testing/examLabels",
        name: "examLabels",
        component: () => import("@/pages/admin/testing/examLabels"),
        meta: {
          activeMenu: "examLabels",
        },
      },
      {
        path: "/background/testing/questionBankAdmin",
        name: "questionBankAdmin",
        component: () => import("@/pages/admin/testing/questionBankAdmin"),
        meta: {
          activeMenu: "questionBankAdmin",
        },
      },
      {
        path: "/background/testing/questionBankAdminDetails",
        name: "questionBankAdminDetails",
        component: () => import("@/pages/admin/testing/questionBankAdminDetails"),
        meta: {
          activeMenu: "questionBankAdmin",
        },
      },
      {
        path: "/background/testing/addAquestion",
        name: "addAquestion",
        component: () => import("@/pages/admin/testing/addAquestion"),
        meta: {
          activeMenu: "testPaper",
        },
      },

      {
        path: "/background/testing/newQuestion",
        name: "newQuestion",
        component: () => import("@/pages/admin/testing/newQuestion"),
        // meta: {
        //   activeMenu: "questionBankAdmin",
        // },
      },
      {
        path: "/background/testing/testPaper",
        name: "testPaper",
        component: () => import("@/pages/admin/testing/testPaper"),
        meta: {
          activeMenu: "testPaper",
        },
      },
      {
        path: "/background/testing/carouselManagement",
        name: "carouselManagement",
        component: () => import("@/pages/admin/testing/carouselManagement"),
        meta: {
          activeMenu: "carouselManagement",
        },
      },
      //题库管理
      {
        path: "/background/exam/platform-source",
        name: "platform-source",
        component: () => import("@/pages/admin/exam/platform-source"),
        meta: {
          activeMenu: "platform-source",
        },
      },
      {
        path: "/background/exam/platform-question",
        name: "platform-question-admin",
        component: () => import("@/pages/admin/exam/platform-question-admin"),
        meta: {
          activeMenu: "platform-question-admin",
          keepAlive: true,
        },
      },
      {
        path: "/background/exam/add-question",
        name: "add-question-admin",
        component: () => import("@/pages/admin/exam/add-question-admin"),
        meta: {
          activeMenu: "platform-question-admin",
        },
      },

      {
        path: "/background/exam/questionlist",
        name: "questionlist-admin",
        component: () => import("@/pages/admin/exam/questionlist-admin"),
        meta: {
          activeMenu: "platform-question-admin",
        },
      },
      //oj
      {
        path: "/background/OjAdmin/ProblemManagement",
        name: "ProblemManagement",
        component: () =>
          import("@/pages/admin/OjAdmin/ProblemManagement/index.vue"),
        meta: {
          activeMenu: "ProblemManagement",
          keepAlive: true,
        },
      },
      {
        path: "/background/OjAdmin/ProblemManagement/addSubject",
        name: "addSubject",
        component: () =>
          import("@/pages/admin/OjAdmin/ProblemManagement/addSubject.vue"),
        meta: {
          activeMenu: "ProblemManagement",
        },
      },
      {
        path: "/background/OjAdmin/TopicAnalysis",
        name: "TopicAnalysis",
        component: () =>
          import("@/pages/admin/OjAdmin/TopicAnalysis/index.vue"),
        meta: {
          activeMenu: "ProblemManagement",
        },
      },
      {
        path: "/background/OjAdmin/subject",
        name: "subject",
        component: () =>
          import("@/pages/admin/OjAdmin/subject/index.vue"),
        meta: {
          activeMenu: "subject",
          keepAlive: true
        },
      },

      {
        path: "/background/OjAdmin/subject/details",
        name: "subjectDetails",
        component: () =>
          import("@/pages/admin/OjAdmin/subject/details.vue"),
        meta: {
          activeMenu: "subject",
        },
      },
      {
        path: "/background/OjAdmin/questionSheetType",
        name: "questionSheetType",
        component: () =>
          import("@/pages/admin/OjAdmin/questionSheetType/index.vue"),
        meta: {
          activeMenu: "questionSheetType",
        },
      },
      {
        path: "/background/OjAdmin/labelManagement",
        name: "labelManagement",
        component: () =>
          import("@/pages/admin/OjAdmin/labelManagement/index.vue"),
        meta: {
          activeMenu: "labelManagement",
        },
      },
      {
        path: "/background/OjAdmin/competitionManagement",
        name: "competitionManagement",
        component: () =>
          import("@/pages/admin/OjAdmin/competitionManagement/index.vue"),
        meta: {
          activeMenu: "competitionManagement",
        },
      },
      {
        path: "/background/OjAdmin/competitionManagement/addCompetitionManagement",
        name: "addCompetitionManagement",
        component: () =>
          import("@/pages/admin/OjAdmin/competitionManagement/addCompetitionManagement.vue"),
        meta: {
          activeMenu: "competitionManagement",
        },
      },
      {
        path: "/background/OjAdmin/competitionManagement/stu",
        name: "stu",
        component: () =>
          import("@/pages/admin/OjAdmin/competitionManagement/stu.vue"),
        meta: {
          activeMenu: "competitionManagement",
        },
      },
      {
        path: "/background/OjAdmin/competitionManagement/problem",
        name: "problem",
        component: () =>
          import("@/pages/admin/OjAdmin/competitionManagement/problem.vue"),
        meta: {
          activeMenu: "competitionManagement",
        },
      },



      {
        path: "/background/cooperative-school",
        name: "cooperative-school",
        component: () =>
          import("@/pages/admin/school-management/cooperative-school"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/background/school-subject-permissions",
        name: "school-subject-permissions",
        component: () =>
          import("@/pages/admin/school-management/school-subject-permissions"),
      },
      {
        path: "/background/school-system-permissions",
        name: "school-system-permissions",
        component: () =>
          import("@/pages/admin/school-management/school-system-permissions"),
      },
      {
        path: "/background/principal-management",
        name: "principal-management",
        component: () =>
          import("@/pages/admin/school-management/principal-management"),
      },
      {
        path: "/background/teacher-management",
        name: "teacher-management",
        component: () =>
          import("@/pages/admin/school-management/teacher-management"),
      },
      {
        path: "/background/BranchManagement",
        name: "BranchManagement",
        component: () =>
          import("@/pages/admin/school-management/BranchManagement"),
      },
      {
        path: "/background/download-management",
        name: "download-management",
        component: () => import("@/pages/admin/school-management/download"),
      },

      {
        path: "/background/school-label",
        name: "school-label",
        component: () => import("@/pages/admin/school-management/school-label"),
      },

      //chatgpt 
      {
        path: "/background/chatgpt",
        name: "chatgpt",
        component: () => import("@/pages/admin/school-management/chatgpt"),
      },

      {
        path: "/background/school-cooperation",
        name: "cooperation-time",
        component: () => import("@/pages/admin/school-management/school-cooperation"),
      },
      //师训管理/培训课程
      {
        path: "/background/teacherTrainingManagement/trainingCourseAdmin",
        name: "training-course-admin",
        component: () =>
          import("@/pages/admin/teacherTrainingManagement/trainingCourseAdmin"),
        meta: {
          activeMenu: "training-course-admin",
        },
      },
      //师训管理/培训课程//添加

      {
        path: "/background/teacherTrainingManagement/addTrainingCourseAdmin",
        name: "add-training-course-admin",
        component: () =>
          import(
            "@/pages/admin/teacherTrainingManagement/addTrainingCourseAdmin"
          ),
        meta: {
          activeMenu: "add-training-course-admin",
        },
      },
      //师训管理/课程章节
      {
        path: "/background/teacherTrainingManagement/trainingCourse",
        name: "catalogue",
        component: () =>
          import("@/pages/admin/teacherTrainingManagement/trainingCourse"),
        meta: {
          activeMenu: "catalogue",
        },
      },
      //师训管理/视频课程
      {
        path: "/background/teacherTrainingManagement/videoCourse",
        name: "video-course",
        component: () =>
          import("@/pages/admin/teacherTrainingManagement/videoCourse"),
        hidden: true,
        meta: {
          activeMenu: "video-course",
        },
      },
      //教研活动/教研活动
      {
        path: "/background/teachingActivities",
        name: "teaching-activities",
        component: () => import("@/pages/admin/teachingActivities"),

        meta: {
          activeMenu: "teaching-activities",
        },
      },
      //教研活动/教研活动?//新增
      {
        path: "/background/teachingActivities/addTeachingActivities",
        name: "addTeachingActivities",
        component: () =>
          import("@/pages/admin/teachingActivities/addTeachingActivities"),

        meta: {
          activeMenu: "addTeachingActivities",
        },
      },

      //平台活动
      {
        path: "/background/basicMaterialOperational",
        name: "basicMaterialOperational",
        component: () =>
          import("@/pages/admin/basicMaterialOperational"),
        meta: {
          activeMenu: "basicMaterialOperational",
        },
      },
      //平台活动/新增

      {
        path: "/background/basicMaterialOperational/addBasicMaterialOperational",
        name: "addBasicMaterialOperational",
        component: () =>
          import("@/pages/admin/basicMaterialOperational/addBasicMaterialOperational.vue"),
        meta: {
          activeMenu: "basicMaterialOperational",
        },
      },
      //平台活动/作品标签
      {
        path: "/background/basicMaterialOperational/tag",
        name: "tag",
        component: () =>
          import("@/pages/admin/basicMaterialOperational/tag.vue"),
        meta: {
          activeMenu: "tag",
        },
      },


      //基础物料
      {
        path: "/background/basicMaterial",
        name: "basicMaterial",
        component: () =>
          import("@/pages/admin/basicMaterial"),
        meta: {
          activeMenu: "basicMaterial",
        },
      },

      //基础物料/新增
      {
        path: "/background/basicMaterial/addBasicMaterial",
        name: "addBasicMaterial",
        component: () =>
          import("@/pages/admin/basicMaterial/addBasicMaterial.vue"),
        meta: {
          activeMenu: "basicMaterial",
        },
      },
      //基础物料/物料标签
      {
        path: "/background/basicMaterial/material",
        name: "material",
        component: () =>
          import("@/pages/admin/basicMaterial/material.vue"),
        meta: {
          activeMenu: "basicMaterial",
        },
      },
      //基础物料/场景标签
      {
        path: "/background/basicMaterial/scene",
        name: "scene",
        component: () =>
          import("@/pages/admin/basicMaterial/scene.vue"),
        meta: {
          activeMenu: "basicMaterial",
        },
      },
      //基础物料/文件类别
      {
        path: "/background/basicMaterial/materialFile",
        name: "materialFile",
        component: () =>
          import("@/pages/admin/basicMaterial/materialFile.vue"),
        meta: {
          activeMenu: "basicMaterial",
        },
      },





      //培训课程
      {
        path: "/background/coursesTraining",
        name: "coursesTraining",
        component: () =>
          import("@/pages/admin/coursesTraining"),
        meta: {
          activeMenu: "coursesTraining",
        },
      },
      //培训课程//添加标签
      {
        path: "/background/coursesTraining/tag",
        name: "classTag",
        component: () =>
          import("@/pages/admin/coursesTraining/tag.vue"),
        meta: {
          activeMenu: "coursesTraining",
        },
      },
      //培训课程//添加
      {
        path: "/background/coursesTraining/addCoursesTraining",
        name: "addCoursesTraining",
        component: () =>
          import("@/pages/admin/coursesTraining/addCoursesTraining.vue"),
        meta: {
          activeMenu: "coursesTraining",
        },
      },
      //培训课程//添加运营章节
      {
        path: "/background/coursesTraining/operationSection",
        name: "operationSection",
        component: () =>
          import("@/pages/admin/coursesTraining/operationSection.vue"),
        meta: {
          activeMenu: "coursesTraining",
        },
      },
      //培训课程//添加运营视频
      {
        path: "/background/coursesTraining/operationVideo",
        name: "operationVideo",
        component: () =>
          import("@/pages/admin/coursesTraining/operationVideo.vue"),
        meta: {
          activeMenu: "coursesTraining",
        },
      },

      //培训课程//文件列表
      {
        path: "/background/coursesTraining/operationFile",
        name: "operationFile",
        component: () =>
          import("@/pages/admin/coursesTraining/operationFile.vue"),
        meta: {
          activeMenu: "coursesTraining",
        },
      },



      //培训视频分类
      {
        path: "/background/course-label",
        name: "course-label",
        component: () =>
          import("@/pages/admin/school-management/train-courses/course-label"),
      },

      //培训视频管理
      {
        path: "/background/course-upload",
        name: "course-upload",
        component: () =>
          import("@/pages/admin/school-management/train-courses/course-upload"),
      },
      //培训视频列表
      {
        path: "/background/courselist",
        name: "courselist",
        component: () =>
          import("@/pages/admin/school-management/train-courses/courselist"),
      },

      //物料分类
      {
        path: "/background/material-label",
        name: "material-label",
        component: () =>
          import("@/pages/admin/school-management/material/material-label"),
      },

      //物料管理
      {
        path: "/background/material-upload",
        name: "material-upload",
        component: () =>
          import("@/pages/admin/school-management/material/material-upload"),
      },
      //录入学校订单

      {
        path: "/background/create-order",
        name: "create-order",
        component: () =>
          import("@/pages/admin/school-management/school-order/create-order"),
        meta: {
          activeMenu: "look-order",
        },
      },
      //查询学校订单

      {
        path: "/background/data-management",
        name: "data-management",
        component: () =>
          import("@/pages/admin/school-management/data-management/index"),
      },
      //学校流量管理
      {
        path: "/background/look-order",
        name: "look-order",
        component: () =>
          import("@/pages/admin/school-management/school-order/look-order"),
      },
      //修改用户信息
      {
        path: "/background/userInformation",
        name: "userInformation",
        component: () =>
          import("@/pages/admin/school-management/userInformation/index.vue"),

      },
      //修改用户信息
      {
        path: "/background/ScreenshotInformation",
        name: "ScreenshotInformation",
        component: () =>
          import("@/pages/admin/school-management/ScreenshotInformation/index.vue"),

      },
      //校区合同

      {
        path: "/background/contract",
        name: "contract",
        component: () =>
          import("@/pages/admin/school-management/contract/index.vue"),
        meta: {
          activeMenu: "contract",
        },
      },

      {
        path: "/background/record",
        name: "record",
        component: () =>
          import("@/pages/admin/school-management/record/index.vue"),
        meta: {
          activeMenu: "record",
        },
      },
      {
        path: "/background/studentList",
        name: "studentList",
        component: () =>
          import("@/pages/admin/school-management/studentList/index.vue"),
        meta: {
          activeMenu: "studentList",
        },
      },
      {
        path: "/background/platformTemplate",
        name: "platformTemplate",
        component: () =>
          import("@/pages/admin/school-management/platformTemplate/index.vue"),
        meta: {
          activeMenu: "platformTemplate",
        },
      },

      {
        path: "/background/campusTemplate",
        name: "campusTemplate",
        component: () =>
          import("@/pages/admin/school-management/campusTemplate/index.vue"),
        meta: {
          activeMenu: "campusTemplate",
        },
      },

      //Background RBAC 权限组
      {
        path: "/background/rbac-nav",
        name: "rbac-nav",
        component: () =>
          import("@/pages/admin/school-management/rbac/rbac-nav"),
        meta: {
          activeMenu: "rbac-nav",
        },
      },

      //超管系统设置
      {
        path: "/background/sysset-nav",
        name: "sysset-nav",
        component: () =>
          import("@/pages/admin/school-management/sysset/rbac/sysset-nav"),
        meta: {
          activeMenu: "sysset-nav",
        },
      },

      //超管员工角色
      {
        path: "/background/sysset-role",
        name: "sysset-role",
        component: () =>
          import("@/pages/admin/school-management/sysset/rbac/sysset-role"),
        meta: {
          activeMenu: "sysset-role",
        },
      },

      //超管新建员工
      {
        path: "/background/sysset-user",
        name: "sysset-user",
        component: () =>
          import("@/pages/admin/school-management/sysset/setting/sysset-user"),
        meta: {
          activeMenu: "sysset-user",
        },
      },

      {
        path: "/background/worktag",
        name: "worktag",
        component: () =>
          import("@/pages/admin/school-management/community/worktag"),
        meta: {
          activeMenu: "worktag",
        },
      },
      //默认社区轮播图
      {
        path: "/background/community-set",
        name: "community-set",
        component: () =>
          import("@/pages/admin/school-management/community/community-set"),
        meta: {
          activeMenu: "community-set",
        },
      },

      {
        path: "/background/rbac-role",
        name: "rbac-role",
        component: () =>
          import("@/pages/admin/school-management/rbac/rbac-role"),
        meta: {
          activeMenu: "rbac-role",
        },
      },
      {
        path: "/background/campuspackage",
        name: "CampusPackage",
        component: () =>
          import("@/pages/admin/school-management/campuspackage/index"),
        meta: {
          activeMenu: "CampusPackage",
        },
      },
      //星币中心
      {
        path: "/background/starCoinCenter/goodsList",
        name: "goodsList",
        component: () => import("@/pages/admin/starCoinCenter/goodsList"),
        meta: {
          activeMenu: "goodsList",
        },
      },
      {
        path: "/background/starCoinCenter/goodsAdd",
        name: "goodsAdd",
        component: () => import("@/pages/admin/starCoinCenter/goodsAdd"),
        meta: {
          activeMenu: "goodsAdd",
        },
      },
      {
        path: "/background/starCoinCenter/goodsEdit",
        name: "goodsEdit",
        component: () => import("@/pages/admin/starCoinCenter/goodsEdit"),
        meta: {
          activeMenu: "goodsEdit",
        },
      },
    ],
  },

  //python代码录入页面
  {
    path: "/background/pyeditor",
    name: "pyeditor",
    component: () => import("@/pages/admin/pyeditor"),
  },

  //python代码录入页面V2
  {
    path: "/background/pyeditor_v2",
    name: "pyeditor_v2",
    component: () => import("@/pages/admin/pyeditor_v2"),
  },

];

export default adminRouterList;
